import { FC, PropsWithChildren } from 'react';

import { Popover } from '@bonusly/design-system';

import { HighlightTabDropdownContext } from './context';

interface HighlightTabDropdownProps extends PropsWithChildren {
	indexOffset: number;
}

export const HighlightTabDropdown: FC<HighlightTabDropdownProps> = ({ children, indexOffset }) => {
	return (
		<HighlightTabDropdownContext.Provider value={{ indexOffset }}>
			<Popover>{children}</Popover>
		</HighlightTabDropdownContext.Provider>
	);
};
